import EmptyPageImage from "@assets/images/emptyPageImage.png";
import "./index.scss";

const NoDataPage = (props) => {
  const {
    onButtonClick,
    showRetryButton,
    buttonText = "Retry",
    title = "No Data Found",
    subTitle = "",
    image = EmptyPageImage,
  } = props;

  return (
    <div className="no-data-page">
      <img src={image} alt="empty-box" className="no-data-page_image" />
      <div className="no-data-page_title">{title}</div>

      <div className="no-data-page_sub-title">{subTitle}</div>

      {showRetryButton && (
        <button className="no-data-page_btn" onClick={onButtonClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default NoDataPage;
